export const DEFAULT_ADMIN_DASHBOARD_CARD_ORDER = Object.freeze([
  'open-operations',
  'system-status',
  'notifications',
  'metrics',
  'web-analytics',
  'scans',
  'portal-requests',
  'logistics',
  'mailbox-display',
  'chat-automation',
  'google-reviews',
  'access-reviews',
  'dashboard-focus',
  'activity',
]);

export function normalizeAdminDashboardCardOrder(value) {
  const requested = Array.isArray(value) ? value : [];
  const uniqueAllowed = requested.filter((cardId, index) => (
    DEFAULT_ADMIN_DASHBOARD_CARD_ORDER.includes(cardId) && requested.indexOf(cardId) === index
  ));
  return [
    ...uniqueAllowed,
    ...DEFAULT_ADMIN_DASHBOARD_CARD_ORDER.filter((cardId) => !uniqueAllowed.includes(cardId)),
  ];
}

export function moveAdminDashboardCard(order, cardId, targetCardId) {
  const normalized = normalizeAdminDashboardCardOrder(order);
  const sourceIndex = normalized.indexOf(cardId);
  const targetIndex = normalized.indexOf(targetCardId);
  if (sourceIndex < 0 || targetIndex < 0 || sourceIndex === targetIndex) return normalized;

  const next = [...normalized];
  next.splice(sourceIndex, 1);
  next.splice(targetIndex, 0, cardId);
  return next;
}

export function moveAdminDashboardCardByOffset(order, cardId, offset) {
  const normalized = normalizeAdminDashboardCardOrder(order);
  const sourceIndex = normalized.indexOf(cardId);
  const targetIndex = Math.max(0, Math.min(normalized.length - 1, sourceIndex + offset));
  if (sourceIndex < 0 || sourceIndex === targetIndex) return normalized;

  const next = [...normalized];
  next.splice(sourceIndex, 1);
  next.splice(targetIndex, 0, cardId);
  return next;
}
